import React from 'react';

import classes from '../installPics.css';

import GM2 from '../../../../../../../assets/GM6.jpg';

const GM2IMG = () => (
    <div className={classes.installImages}>
        <img alt="A Ground mount Solar Array" src={GM2} className={classes.installImg} />
    </div>
);


export default GM2IMG;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/GroundMountImages/GM5.js